module.exports = __webpack_public_path__ + "img/device_01.d03b0d40.jpg";